<template>

  <component :is="(member)? 'router-link' : 'div'" :to="`/oscar-pool/${club._id}`" class="card club-card" :class="{'faded': markedForDeletion}">
    <div class="card-body">
      <div class="d-flex">
        <div class="p-2 w-100">
          <a v-if="pendingMember" class="cancel-join-request" href="#" title="cancel request" @click.prevent="cancelJoinRequest">
            <i class="fa fa-user-times"></i>
          </a>
          <a v-if="markedForDeletion" class="cancel-deletion-request" href="#" title="cancel deletion" @click.prevent="cancelDeleteRequest">
            <i class="fa fa-undo"></i>
          </a>
          <ClubPicture :club="club" size="50"></ClubPicture>
          <div class="club-description">
            <div><h4 class="club-name">{{club.name}}</h4></div>
            <div class="member-count" v-text="`${club.memberCount} member${(club.memberCount !== 1)? 's' : ''}`"></div>
          </div>
        </div>
      </div>
    </div>
  </component>

</template>


<script>
import axios from "axios";
import ClubPicture from "@/components/clubs/ClubPicture.vue";

export default {
  name: 'ClubCard_CreateClub',
  props: ['club', 'my_membership'],
  emits: ['update-clubs-list'],
  components: {ClubPicture},
  computed: {
    member() {
      return ( this.my_membership && (this.my_membership.role !== 'pending') );
    },
    pendingMember() {
      return ( this.my_membership?.role === 'pending' );
    },
    markedForDeletion() {
      return this.club?.marked_for_deletion;
    }
  },
  data() {
    return {
    }
  },
  methods: {
    async cancelJoinRequest() {
      return axios.post(`/api/club/leave`, { club_id: this.club._id })
          .then((/*response*/) => {
            //console.log('/club/leave', response.data);
            this.$emit('update-clubs-list');
          })
          .catch(err => {
            console.log(err);
          });
    },

    async cancelDeleteRequest() {
      return axios.post(`/api/club/mark-for-delete`, {
        club_id: this.club._id,
        mark: false
      })
          .then((/*response*/) => {
            this.$emit('update-clubs-list');
          })
          .catch(err => {
            console.log(err);
          });
    }
  }
}
</script>


<style scoped>

.club-card {
  isolation: isolate;
  overflow: hidden;
  min-height: 110px;

  text-decoration: inherit;

  background-color: var(--mol-color-gold-background);
  border-color: var(--mol-color-gold);
  color: var(--mol-color-gold-text);
  margin: 18px;
}

/* outline on hover, but only if club-card is a link */
a.club-card:hover {
  box-shadow: 0 0 0 1px var(--mol-color-gold);
}


.club-profile-pic {
  position: relative;
  border-radius: 20%;
  border-style: solid;
  border-width: 0.1px;
  border-color: lightgrey;
  margin-top: -4px;
}

.club-description {
  position: absolute;
  display: inline-block;

  top: 20px;
  right: 0;
  left: 90px;

  .club-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .member-count {
    margin-top: -0.6em;
    margin-left: 0.5em;
  }
}

.cancel-join-request {
  color: var(--mol-color-gold-faded);
  float: right;
  width: fit-content;

  &:hover {
    color: var(--mol-color-gold);
  }
}

.cancel-deletion-request {
  color: var(--mol-color-gold-faded);
  float: right;
  width: fit-content;

  &:hover {
    color: var(--mol-color-gold);
  }
}

.faded {

  border-color: var(--mol-color-gold-faded);

  .club-profile-pic {
    opacity: 50%;
  }
  .club-description {
    opacity: 40%;
  }

}


</style>